var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"persistent":"","hide-overlay":_vm.hide_overlay,"max-width":_vm.width,"scrollable":_vm.scrollable,"retain-focus":_vm.retainfocus},model:{value:(_vm.DIALOGS),callback:function ($$v) {_vm.DIALOGS=$$v},expression:"DIALOGS"}},[_c(_vm.cp,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }